import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@/pages/Home/Home.vue';
import NotFound from '@/pages/404/404.vue';

Vue.use(VueRouter);

const routes = [
  // {
  //   path: '/',
  //   redirect: '/auth'
  // },
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '*',
    name: 'notFound',
    component: NotFound
  },
];

const router = new VueRouter({
  base: '/web',
  routes,
  mode: 'history'
});

// 登录态控制路由规则
router.beforeEach((to, from, next) => {
  next();
})

export default router;
